/*
 * borisFlag.js — WP-SPLIT
 *
 * Is Boris switched on in this build? On in development, off in production
 * unless REACT_APP_ENABLE_BORIS_ASSISTANT says otherwise.
 *
 * This lives here, away from BorisAssistant.js, for the same reason
 * sessionKeys.js exists: App.js has to know the answer *before* it decides
 * whether to fetch Boris at all. Reading the flag out of the component file
 * would download the whole Boris chunk — videos, chat, the lot — only to find
 * out he is turned off. BorisAssistant.js imports the flag from here and still
 * re-exports it, so nothing else had to change.
 */

const FLAG = process.env.REACT_APP_ENABLE_BORIS_ASSISTANT;

export const BORIS_ENABLED =
  FLAG === 'true' ? true : FLAG === 'false' ? false : process.env.NODE_ENV !== 'production';

export default BORIS_ENABLED;
